import * as ng from 'angular';
import * as uir from '@uirouter/angularjs';

import { SessionService } from '../../shared';

export class OrgEditController {
   static $inject = [
      '$state', '$stateParams', '$window', 'orgsApi', 'dialogs', 'session',
      'toast', 'loader', 'titleService'
   ];

   constructor(
      private $state:uir.StateService,
      $stateParams:uir.StateParams,
      private $window:ng.IWindowService,
      private orgsApi,
      private dialogs,
      private session:SessionService,
      private toast,
      private loader,
      titleService
   ) {
      titleService.setTitle('Organization Details');

      this.isCreate = $state.current.name == 'orgAdd';

      if (this.isCreate) {
         this.model = {};
      } else {
         let orgToEdit = $stateParams.id ? this.session.getOrg($stateParams.id) : this.session.getOrg();
         this.model = ng.copy(orgToEdit);
      }

      this.removeTrialSelection();
   }

   acctTypes = {
      'trial': 'Trial',
      'standard': 'Standard',
      'proplus': 'Pro Plus'
   };

   isCreate:boolean;
   model;

   goBack() {
      this.$window.history.back();
   }

   save(form:ng.IFormController) {
      if (this.model.account && !this.model.account.type) {
         // nullify account object when type is changed to "None"
         this.model.account = null;
      }

      this.loader.showSpinner();

      if (this.isCreate) {
         this.orgsApi.create(this.model).then((org) => {
            this.model = org;
            this.removeTrialSelection();
            return this.session.refreshUser({orgId: org.id});
         }).then(() => {
            this.toast.success()
               .title('Organization created successfully')
               .message('You can now add a new brand under this organization')
               .send();

            this.$state.go('addBrand');
         }).finally(() => this.loader.hide());
      } else {
         this.orgsApi.update(this.model).then((org) => {
            this.model = org;
            return this.session.refreshUser();
         }).then(() => {
            this.toast.success()
               .message('Organization updated successfully')
               .send();

            form.$setPristine();
         }).finally(() => this.loader.hide());
      }
   }

   del() {
      this.dialogs.confirm('Are you sure you want to delete this organization?').then(() => {
         this.loader.showSpinner();

         this.orgsApi.del(this.model.id)
            .then(() => this.session.refreshUser())
            .then(() => this.$state.go('dashboard'))
            .then(() => {
               this.toast.message(`Organization "${this.model.name}" was deleted`).send();
            }).catch((response) => {
               let msg = response.data ? response.data : 'Internal error, please file a bug report';
               this.dialogs.alert(`Could not delete ${this.model.name}. Reason: ${msg}`);
            }).finally(() => this.loader.hide());
      });
   }

   // remove trial selection if acct is pro/proplus (why?)
   private removeTrialSelection() {
      if (this.model.account
         && this.model.account.type
         && this.model.account.type !== 'trial') {
         delete this.acctTypes.trial;
      }
   }
}

ng.module('e360').controller('OrgEditController', OrgEditController);
